﻿import {translation} from "@2d-front-monorepo/core";
import {
	ConstructionNumber,
	formatDate,
	formatTime,
	Meters, ReservationBlocks,
	ReservationId,
	Reservations,
	ReservationStatusComponent,
	Tariffs
} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";

import {JSX} from "react";
import {useParams} from "react-router";
import InvalidReservation from "../../components/InvalidReservation";
import {PermitsBackButtonFrame} from "../../components/PermitsBackButton";
import {getGlobalContext} from "../../hooks/getGlobalContext";
import {usePermits} from "../../hooks/usePermits";
import {PrivateRoutes} from "../../routes";


export default function ViewReservation(): JSX.Element {
	const {reservationId} = useParams<{ reservationId: string }>() as { reservationId: ReservationId };
	const {installation} = getGlobalContext();
	const permitsState = usePermits();
	const reservation = Reservations.find(permitsState, reservationId);

	if (reservation == null) {
		return <InvalidReservation reservationId={reservationId}/>;
	}

	const tariff = Tariffs.get(installation, reservation.tariffId);

	return <>
		<div className="layout horizontal aligned middle">
			<h2 className="flex">{tariff.title}</h2>
			<ReservationStatusComponent reservation={reservation}/>
		</div>
		<hr className="no-margin-start"/>

		<div className="layout vertical gap">
			<div className="card card--padded">
				<dl className="title-desc">
					<dt>{translation(PermitTranslations.purpose)}</dt>
					<dd>{reservation.purpose}</dd>
				</dl>
			</div>

			<div className="card card--padded">
				<div className="grid">
					<dl className="title-desc col-1of2">
						<dt>{translation(PermitTranslations.start_date)}</dt>
						<dd>{formatDate(reservation.startDate.toDateOnly())}</dd>
					</dl>
					<dl className="title-desc col-1of2">
						<dt>{translation(PermitTranslations.end_date)}</dt>
						<dd>{formatDate(reservation.endDate.toDateOnly())}</dd>
					</dl>
					<dl className="title-desc col-1of2">
						<dt>{translation(PermitTranslations.start_time)}</dt>
						<dd>{formatTime(reservation.startDate.toTimeOnly())}</dd>
					</dl>
					<dl className="title-desc col-1of2">
						<dt>{translation(PermitTranslations.end_time)}</dt>
						<dd>{formatTime(reservation.endDate.toTimeOnly())}</dd>
					</dl>
				</div>
			</div>

			<ConstructionNumber data={reservation} keyName={"DOMI"}/>
			<ReservationBlocks blocks={reservation.blocks} installation={installation}/>
			<Meters meters={reservation.meters}/>
		</div>
		<PermitsBackButtonFrame href={PrivateRoutes.permitsList}/>
	</>;
}
